// extracted by mini-css-extract-plugin
export var sky = "design-module--sky--2gS5n";
export var darkSky = "design-module--dark-sky--UKSd1";
export var skyLightBackground = "design-module--sky-light-background--3husZ";
export var mountainLeft = "design-module--mountain-left--3kyZp";
export var mountainRight = "design-module--mountain-right--3IjJ1";
export var skyLight = "design-module--sky-light--3gP_x";
export var cloud = "design-module--cloud--19Hvz";
export var cloudLight = "design-module--cloud-light--32sCT";